import React, { useState, useEffect, memo } from 'react';
import { IonLabel, IonButton, IonModal, IonRow, IonCol, IonItem } from '@ionic/react';
import '../../../pages/Search/New/NewPage.scss';
import { NewDropDownData } from '../../../utils/mock_Data';
import { Trailer } from '../../../utils/constants';
import { useTranslation } from 'react-i18next';
interface DropDownProps {
    labelName: string;
    TrailerType: string;
    handleChange: any;

}
export const NewDropDown: React.FC<DropDownProps> = memo((props:any) => {
    const { labelName, TrailerType, handleChange } = props;
    const [showOptions, setShowOptions] = useState(false);
    const [clickedOption, setclickedOption] = useState({ name: TrailerType, value: TrailerType });
    const [selectedOption, setselectedOption] = useState({ name: TrailerType, value: TrailerType });
    const hideDropdownMenu = (option: any) => {
        setclickedOption(option);
    }
    const onConfirm = (option: any) => {
        setselectedOption(option);
        setShowOptions(false);
        const event = { target: { name: Trailer, value: option.value } }
        handleChange(event);
    }
    const { t } = useTranslation();
    useEffect(() => {
        setclickedOption({name: TrailerType, value: TrailerType })
        setselectedOption({name: TrailerType, value: TrailerType })
    }, [props.TrailerType])

    return (
        <>
        <IonItem class=" trailer-ion-item" lines='none'>
            <IonLabel mode="ios" class="trailer_type_label">{t(labelName)}</IonLabel>
            <IonButton type="button" class="dropdown-button trailer_type_dropdown" data-testid ="dropdown-click"
            onClick={() => (setShowOptions(true))}>
               <span>{t(selectedOption.value)}</span><i className="down"></i>
            </IonButton>
        </IonItem>
        <IonModal isOpen={showOptions} cssClass="dropdown-modal"
            backdropDismiss={false}
            onDidDismiss={() => (setShowOptions(false))}
            data-testid = "dropdown-modal"
            >
                <div className="search_options_trailer">
                    <IonRow class="dropdown-heading"><IonCol> <p className="sortBy_text">{labelName}</p> </IonCol></IonRow>
                    <div className="options_content_trailer">
                        {NewDropDownData.map((option: any, k: any) => (
                            <IonRow class="dropdown-row" key={k} data-testid="hide-dropdown" onClick={() => hideDropdownMenu(option)}>
                                <IonCol class={option.name === clickedOption.name ? 'checked' : ''}>{t(option.value)} <i className="check"></i> </IonCol></IonRow>
                        ))}
                                  </div>
                        <IonRow className="ion-margin">
                            <IonCol size="6" className="ion-text-right">
                            <IonButton
                              className="secondary-cta-btn-mobile"
                              data-testid="dropdown-cancel"
                              onClick={() => { setShowOptions(false);
                                setclickedOption(selectedOption) } }
                            >
                             {t('Cancel')}
                            </IonButton>
                            </IonCol>
                            <IonCol size="6" className="ion-text-left">
                            <IonButton
                              className="primary-cta-btn-mobile"
                              data-test="validate-btn"
                              onClick={() => onConfirm(clickedOption)}
                            >
                                {t('Ok_TEXT')}
                            </IonButton>
                            </IonCol>
                        </IonRow>
                </div>
            </IonModal>
        </>
    );
});
